/* eslint-disable react/prop-types */
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CFormInput } from '@coreui/react'
export default function CountryDropdown(props) {
  const { t } = useTranslation()
  return <CFormInput type={'text'} id={`text-input-country`} {...props} />
}
